import { memo, useMemo } from "react";
import { Drawer, Tabs, Space, Alert, Typography } from "antd";
import { WarningOutlined } from "@ant-design/icons";
import styles from "../styles/UberSyncUI.module.css";

const { Text } = Typography;
const { TabPane } = Tabs;

const ExclusionsDetailDrawer = ({ visible, exclusions, discrepancies, onClose }) => {
  const categoryExclusions = useMemo(() => 
    exclusions ? exclusions.filter(ex => ex.type === "category") : []
  , [exclusions]);

  const productExclusions = useMemo(() => 
    exclusions ? exclusions.filter(ex => ex.type === "product") : []
  , [exclusions]);

  const apiDiscrepancies = discrepancies || [];

  return (
    <Drawer
      title={
      <div className={styles.drawerTitleWrapper}>
        <WarningOutlined className={`${styles.drawerTitleIcon} ${styles.Warning}`} />
        <span className={styles.drawerTitleText}>Vista Ampliada de Conflictos y Exclusiones</span>
      </div>
      }
      placement="right"
      width={window.innerWidth < 768 ? "100%" : 600}
      onClose={onClose}
      visible={visible}
      destroyOnClose
    >
      <div>
        <Tabs defaultActiveKey={apiDiscrepancies.length > 0 ? "discrepancies" : "categories"}>
          <TabPane
            tab={
              <span className={apiDiscrepancies.length > 0 ? styles.tabTitleWarning : ""}>
                Discrepancias API ({apiDiscrepancies.length})
              </span>
            }
            key="discrepancies"
          >
            <div style={{ maxHeight: 'calc(100vh - 180px)', overflowY: 'auto', paddingRight: '8px', paddingTop: '10px' }}>
              {apiDiscrepancies.length > 0 ? (
                apiDiscrepancies.map((disc, idx) => (
                  <div key={idx} className={styles.exclusionItem} style={{ marginBottom: '8px' }}>
                    <Space align="start">
                      <WarningOutlined className={styles.warningIconColor} />
                      <div>
                        <Text strong className={styles.branchNameText}>
                          {disc.type === 'MISSING_MODIFIER_ITEM' ? `Item no encontrado: ${disc.missingItemId}` : `Item sin precio: ${disc.itemId}`}
                        </Text>
                        <div className={styles.exclusionReason}>{disc.message}</div>
                      </div>
                    </Space>
                  </div>
                ))
              ) : (
                <Alert
                  message="Sin discrepancias de formato"
                  description="El payload a enviar está limpio y todos los condimentos referenciados existen."
                  type="success"
                  showIcon
                />
              )}
            </div>
          </TabPane>

          <TabPane
            tab={
              <span className={categoryExclusions.length > 0 ? styles.tabTitleWarning : ""}>
                Categorías ({categoryExclusions.length})
              </span>
            }
            key="categories"
          >
            <div style={{ maxHeight: 'calc(100vh - 180px)', overflowY: 'auto', paddingRight: '8px', paddingTop: '10px' }}>
              {categoryExclusions.length > 0 ? (
                categoryExclusions.map((ex, idx) => (
                  <div key={idx} className={styles.exclusionItem} style={{ marginBottom: '8px' }}>
                    <Space align="start">
                      <WarningOutlined className={styles.warningIconColor} />
                      <div>
                        <Text strong className={styles.branchNameText}>
                          {ex.name}
                        </Text>
                        <div className={styles.exclusionReason}>{ex.reason}</div>
                      </div>
                    </Space>
                  </div>
                ))
              ) : (
                <Alert
                  message="Sin advertencias para categorías"
                  description="Todas las categorías se encuentran habilitadas."
                  type="success"
                  showIcon
                />
              )}
            </div>
          </TabPane>

          <TabPane
            tab={
              <span className={productExclusions.length > 0 ? styles.tabTitleWarning : ""}>
                Productos ({productExclusions.length})
              </span>
            }
            key="products"
          >
            <div style={{ maxHeight: 'calc(100vh - 180px)', overflowY: 'auto', paddingRight: '8px', paddingTop: '10px' }}>
              {productExclusions.length > 0 ? (
                productExclusions.map((ex, idx) => (
                  <div key={idx} className={styles.exclusionItem} style={{ marginBottom: '8px' }}>
                    <Space align="start">
                      <WarningOutlined className={styles.warningIconColor} />
                      <div>
                        <Text strong className={styles.branchNameText}>
                          {ex.name}
                        </Text>
                        <div><Text type="secondary" className={styles.skuText}>SKU: {ex.sku} | Categoría: {ex.categoryName}</Text></div>
                        <div className={styles.exclusionReason}>{ex.reason}</div>
                      </div>
                    </Space>
                  </div>
                ))
              ) : (
                <Alert
                  message="Sin advertencias para productos"
                  description="Todos los productos activos están disponibles para sincronización."
                  type="success"
                  showIcon
                />
              )}
            </div>
          </TabPane>
        </Tabs>
      </div>
    </Drawer>
  );
};

export default memo(ExclusionsDetailDrawer);
